// extracted by mini-css-extract-plugin
module.exports = {"expand":"ExpandButton_expand__YYIIn","light":"ExpandButton_light__257BC"};